@use "../../styles/base.scss" as *;

@media screen and (max-width: $breakpoint2) {
  .SearchBar.focused {
    position: absolute;
    top: 51px;
    width: 100%;
  }
}
